module.exports = __webpack_public_path__ + "a96dc2a9684ed2f3204fd8b32a53c44b.woff";